import api from "@/lib/api";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

/** POST a file; if the server answers with a job_id, poll /jobs/{id} until done. onProgress({done,total}). Returns final result (+ job_id). */
export async function runImport(url, file, onProgress, extraForm = {}) {
  const fd = new FormData();
  fd.append("file", file);
  Object.entries(extraForm).forEach(([k, v]) => fd.append(k, v));
  onProgress?.({ done: 0, total: 0 });
  let { data } = await api.post(url, fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0 });
  if (data.job_id) {
    const jobId = data.job_id;
    onProgress?.({ done: 0, total: data.rows });
    for (;;) {
      await sleep(800);
      const { data: j } = await api.get(`/jobs/${jobId}`);
      onProgress?.({ done: j.done, total: j.total || data.rows });
      if (j.status === "error") throw new Error(j.error || "Import failed");
      if (j.status === "done") { data = { ...(j.result || {}), job_id: jobId }; break; }
    }
  }
  return data;
}

export async function downloadSkipped(jobId) {
  const res = await api.get(`/jobs/${jobId}/skipped.xlsx`, { responseType: "blob" });
  const u = URL.createObjectURL(res.data); const a = document.createElement("a"); a.href = u; a.download = `skipped_rows.xlsx`; a.click(); URL.revokeObjectURL(u);
}

export const progressLabel = (p) => (!p ? "" : p.total ? `Importing ${Math.min(p.done, p.total)}/${p.total}…` : "Reading file…");
